<template>
    <div class="modal fade" id="createTaskModal" role="dialog" aria-labelledby="createTaskModalLabel" backdrop="static" data-backdrop="static" aria-hidden="true">
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header mt-3 mb-0">
                    <h5 class="modal-title" id="createTaskModalLabel"><i class="far fa-plus-square text-success mr-2"></i>{{$t('scheduler.appointmentCreate')}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <HallEventEditCard v-model="model"
                                       v-if="showEditor"
                                       :create="true"
                                       :event-details="eventDetails"
                                       :eventId="eventId"
                                       :allowSave="true"
                                       :allowDelete="true"
                                       @save="onSave"
                                       @delete="onDelete"
                                       @cancel="onCancel">
                    </HallEventEditCard>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { EventDetails, ScheduleTask } from '../../models/models';
    import HallEventEditCard from './HallEventEditCard';
    import eventService from "../../services/event.service";

    export default {
        components: {
            HallEventEditCard
        },
        props: {
            show: {
                type: Boolean,
                default: false
            },
            eventId: {
                type: Number,
            }
        },
        data() {
            return {
                showEditor: false,
                model: new ScheduleTask(),
                eventDetails: new EventDetails(),
            };
        },
        methods: {
            onClose() {
                this.$emit('onClose', { ...this.model });
                this.model = new ScheduleTask();
                this.eventDetails = new EventDetails();
                this.$validator.reset();
            },
            hide() {
                $(this.$el).modal('hide');
            },
            onSave(model) {
                this.$emit('onCreate', model);
                this.onClose();
            },
            onDelete(id) {
                this.$emit('onDelete', id);
                this.onClose();
            },
            onCancel() {
                this.onClose();
            },
            loadEventDetails(eventId) {
                if (!eventId) return;

                return new Promise((resolve, reject) => {
                    eventService
                        .getDetails(eventId)
                        .then(response => {
                            if (response.data) {
                                this.eventDetails = new EventDetails(response.data);

                                resolve(true);
                            } else {
                                this.$vs.notify({
                                    title: this.$t('request.response.status.' + this.$helpers.responseStatusCode(response)),
                                    text: this.$helpers.responseMessage(response),
                                    color: 'warning',
                                    time: this.$store.getters.notificationDuration
                                });
                            }
                        })
                        .catch(error => {
                            this.$vs.notify({
                                title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                                text: this.$helpers.errorText(error),
                                color: this.$helpers.errorColor(error),
                                time: this.$store.getters.notificationDuration
                            })

                            reject(error);
                        });
                });
            },
        },
        mounted() {
            // add modal close listener
            $(this.$el).on('hidden.bs.modal', this.onClose);
        },
        beforeDestroy() {
            // remove listener
            $(this.$el).off('hidden.bs.modal');
        },
        watch: {
            show: function (val) {
                if (val) {
                    this.model = new ScheduleTask();
                    this.model.eventId = this.eventId;
                    this.model.placeIdStr = '';
                    this.model.hallIdStr = '';

                    let num = Number(this.eventId);
                    if (!isNaN(num) && num > 0) {
                        this.model.eventIdStr = num.toString();
                        this.model.mapVenueToEvent = true;
                    } else {
                        this.model.eventIdStr = '';
                    }

                    this.loadEventDetails(this.model.eventId);
                    this.showEditor = true;
                    $(this.$el).modal('show');
                } else {
                    $(this.$el).modal('hide');
                    this.showEditor = false;
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    .bmd-form-group {
        padding-top: 0px !important;
    }
</style>
